import { Component, HostListener, ViewChild, ElementRef } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from '@pg-app/core/services/auth.service';
import { RegistrationStep2Service } from '@pg-app/client/services/registrationStep2.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { CheckAccountComponent } from '@pg-app/client/client-dashboard/dialogs/check-account/check-account.component';
import { LeadType } from '@nttp/enum/lead-type.enum';
import { ShareService } from '@nttp/common-service/share-service';
import { UserRoleEnum } from '@nttp/enum/user-role.enum';
import { InternalTransferService } from '@pg-app/client/payment/services/internal-transfer-service';
import { environment } from '@pg-env/environment';
import { LoginInfoService } from '@pg-app/auth/services/login-info.service';
import { ClientProfileService } from '@pg-app/client/services/client-profile.service';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormControl } from '@angular/forms';
import { StoreProvider } from '@pg-app/core/services/storeProvider/store.provider';
import { CommonDialogComponent } from '@pg-app/common/common-dialog/common-dialog.component';

@Component({
  selector: 'np-client-nav',
  templateUrl: './client-nav.component.html',
  styleUrls: ['./client-nav.component.scss']
})
export class ClientNavComponent {
  public showHideMenu = true;
  public showHideSubMenu = true;
  public showHideExternalFunds = true;
  public showPaymentImportSubMenu = false;
  firstName: string;
  notVerify = false;
  @ViewChild('menu', { static: true })
  menu: ElementRef;
  isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(map(result => result.matches));
  userInfo = {
    fullName: '',
    firstName: '',
    accountNumber: '',
    accountName: ''
  };

  roleList = ['Read only', 'Administrator', 'Initiator', 'Validator'];
  userRoleName = '';

  userDetail = null;
  leadName = '';

  leadTypeEnum = LeadType;
  userRoleEnum = UserRoleEnum;

  approvedForInternalTransfers = false;
  profiles = [];
  profileSwitchingForm: any;
  showAccountSelection = false;
  
  get accountCtrl() {
    return this.profileSwitchingForm.get('account') as FormControl;
  }

  constructor(
    private fb: FormBuilder,
    private breakpointObserver: BreakpointObserver,
    private authService: AuthService,
    private router: Router,
    private dialog: MatDialog,
    private shareService: ShareService,
    private clientService: ClientProfileService,
    private toastr: ToastrService,
    private store: StoreProvider,
    public registrationStep2Service: RegistrationStep2Service,
    
  ) {
    this.getIsStep2Complete();
  }

  @HostListener('click', ['$event'])
  public lostFocus(event) {
    if (
      (event.target as HTMLElement).matches('.menu-user,.target-click') ||
      this.menu.nativeElement.contains(event.target)
    ) {
      return;
    }
    this.showHideMenu = true;
  }

  ngOnInit() {
    this.profileSwitchingForm = this.fb.group({
      account: ''
    });
  }

  changeProfile() {
    if (this.accountCtrl.value) {
      var selectedAccount = this.profiles.find(u => u.leadId == this.accountCtrl.value);
      if (selectedAccount.isAccepted == false) {
        this.toastr.error(
          `Please contact your Relationship Manager for an update on access to your account. You can contact them via email help@${environment.domain} or phone ${environment.phone}`
        );
        this.accountCtrl.setValue(this.userDetail.id); 
        return;
      }

      this.dialog.open(CommonDialogComponent, {
        data: {
          title: `Are you sure you want to switch to ${selectedAccount.leadName} (${selectedAccount.leadCode})?<BR> Any unconfirmed actions on this page will be lost`,
          dialogType: 2
        }
      }).afterClosed()
        .subscribe(result => {
          if (result) {
              var leadId =  this.accountCtrl.value;
              var email = this.userDetail.email;
              var clientId = environment.clientId;
              var data = {
                leadId: leadId,
                email: email,
                clientId: clientId,
                leadName: selectedAccount.leadName
              };

              this.clientService.changeSelectedAccount(data).subscribe(res => {
              this.authService.updateAccessToken(res);
              this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=>
              this.router.navigate(['client/dashboard']));
            });
          }
          else {
            this.accountCtrl.setValue(this.userDetail.id);
          }
        });
    }
  }

  loadUserProfiles() {
    var data =  {email: this.userDetail.email};
    this.clientService.getProfiles(data).subscribe(res => {
      this.profiles = res || [];
      this.profiles.forEach(p => p.leadCodeAndName = p.leadCode + ', ' + p.leadName);
      this.accountCtrl.setValue(this.userDetail.id);
      this.showAccountSelection = this.profiles.length > 1;
    },
     error => {
      if (error.message) {
        this.toastr.error(error.message);
      } else {
        throw error;
      }
    });
  }

  showMenu() {
    this.showHideMenu = !this.showHideMenu;
  }

  hideMenu() {
    this.showHideMenu = true;
  }

  logout() {
    this.authService.logout();
  }

  getIsStep2Complete() {
    this.shareService.getAccountType(true).subscribe(data => {
      this.userDetail = data;
      this.userRoleName = this.roleList[data.clientRole];
      this.registrationStep2Service.dualAuthorization = data.dualAuthorization;
      this.registrationStep2Service.transferDualAuthorization = data.transferDualAuthorization;
      this.registrationStep2Service.userRole = data.clientRole;
      this.registrationStep2Service.leadType = data.leadType;
      this.registrationStep2Service.email = data.email;
      this.approvedForInternalTransfers = data.approvedForInternalTransfers;
      
      this.userInfo = {
        fullName: data.fullName,
        firstName: data.fullName.split(' ')[0],
        accountNumber: data.accountNumber,
        accountName: data.accountName ?? data.fullName
      };
      if (typeof window['Upscope'] !== 'undefined') {
        window['Upscope']('updateConnection', { identities: [data.accountNumber], uniqueId: data.fullName });
      }

      this.loadUserProfiles();

      if (!data.isStep2Completed) {
        this.notVerify = true;
        const dialogRef = this.dialog.open(CheckAccountComponent, {
          disableClose: true,
          data: {
            hasButton: true,
            message: 'Please complete your account registration.'
          }
        });
        dialogRef.afterClosed().subscribe(result => {
          this.router.navigate(['client/register/step-2']);
        });
      } else if (!data.accountNumber) {
        this.notVerify = true;
        const message = data.leadType === LeadType.Private ?
          'We are reviewing your application.<br> Once approved you will receive a welcome on board email with a link to log back in to your portal.' :
          'We are reviewing your application and we will email you when it is complete.<br> Please log back in after receiving the email';

        const dialogRef = this.dialog.open(CheckAccountComponent, {
          disableClose: true,
          data: {
            hasButton: data.leadType === LeadType.Private ? true : false,
            message: message,
            buttonText: data.leadType === LeadType.Private ? 'Logout' : null,
          }
        });
        dialogRef.afterClosed().subscribe(result => {
          this.authService.logout();
        });
      } else {
        this.registrationStep2Service.complianceRisk().subscribe(
          result => {
            if (result) {
              this.dialog.open(CheckAccountComponent, {
                disableClose: true,
                data: {
                  hasButton: true,
                  // tslint:disable-next-line:max-line-length
                  message:
                  `Please contact your Relationship Manager for an update on access to your account. <br> You can contact them via email help@${environment.domain} or phone ${environment.phone}  `
                }
              });
            }
          }
        );
      }
    });
  }

  public showSubMenu() {
    this.showHideSubMenu = !this.showHideSubMenu;
  }

  public hideSubMenu() {
    this.showHideSubMenu = true;
  }

  public togglePaymentImportSubMenu() {
    this.showPaymentImportSubMenu = !this.showPaymentImportSubMenu;
  }

  public hidePaymentImportSubMenu() {
    this.showPaymentImportSubMenu = false;
  }
}
